/* eslint-disable no-confusing-arrow, no-nested-ternary, comma-dangle, no-unneeded-ternary, max-len */
import { toastr } from 'react-redux-toastr';
import { I18n } from 'src/translations/i18n';

import {
  pathOr, union, map
} from 'ramda';

import dayjs from 'dayjs';

import Utils from 'src/utils';
import { WTS_MOMENT_DATE_MASK } from 'src/constants/dayjs';
import toastrError from 'src/helpers/toastr/toastrError';
import toastrSuccess from 'src/helpers/toastr/toastrSuccess';
import communicate from 'src/api/communicate';
import { wtsApi } from 'src/api';
import VirtualEventsTable from './tools/VirtualEventsTable';

export const LOAD_USER_JOBS_SUCCESS = 'LOAD_USER_JOBS_SUCCESS';
export const LOAD_USER_JOBS_FAIL = 'LOAD_USER_JOBS_FAIL';
export const LOAD_USER_JOBS_REQUEST = 'LOAD_USER_JOBS_REQUEST';

export const LOAD_FAULTY_EVENTS_REQUEST = 'LOAD_FAULTY_EVENTS_REQUEST';
export const LOAD_FAULTY_EVENTS_FAIL = 'LOAD_FAULTY_EVENTS_FAIL';
export const LOAD_FAULTY_EVENTS_SUCCESS = 'LOAD_FAULTY_EVENTS_SUCCESS';

export const LOAD_USER_JOBS_IN_PERIOD_SUCCESS = 'LOAD_USER_JOBS_IN_PERIOD_SUCCESS';
export const LOAD_USER_JOBS_IN_PERIOD_FAIL = 'LOAD_USER_JOBS_IN_PERIOD_FAIL';
export const LOAD_USER_JOBS_IN_PERIOD_REQUEST = 'LOAD_USER_JOBS_IN_PERIOD_REQUEST';

export const LOAD_CALENDAR_EVENTS_REQUEST = 'LOAD_CALENDAR_EVENTS_REQUEST';
export const LOAD_CALENDAR_EVENTS_FAIL = 'LOAD_CALENDAR_EVENTS_FAIL';
export const LOAD_CALENDAR_EVENTS_SUCCESS = 'LOAD_CALENDAR_EVENTS_SUCCESS';

export const UPDATE_MANY_USERS_JOBS_IN_PERIOD = 'UPDATE_MANY_USERS_JOBS_IN_PERIOD';

export const LOAD_USER_JOBS_IN_DAY_SUCCESS = 'LOAD_USER_JOBS_IN_DAY_SUCCESS';
export const LOAD_USER_JOBS_IN_DAY_FAIL = 'LOAD_USER_JOBS_IN_DAY_FAIL';
export const LOAD_USER_JOBS_IN_DAY_REQUEST = 'LOAD_USER_JOBS_IN_DAY_REQUEST';


export const LOAD_TOTAL_WORK_IN_PERIOD_SUCCESS = 'LOAD_TOTAL_WORK_IN_PERIOD_SUCCESS';
export const LOAD_TOTAL_WORK_IN_PERIOD_FAIL = 'LOAD_TOTAL_WORK_IN_PERIOD_FAIL';
export const LOAD_TOTAL_WORK_IN_PERIOD_REQUEST = 'LOAD_TOTAL_WORK_IN_PERIOD_REQUEST';

export const PUT_JOB_DONE_SUCCESS = 'PUT_JOB_DONE_SUCCESS';
export const PUT_JOB_DONE_FAIL = 'PUT_JOB_DONE_FAIL';
export const PUT_JOB_DONE_REQUEST = 'PUT_JOB_DONE_REQUEST';

export const DELETE_JOB_DONE_SUCCESS = 'DELETE_JOB_DONE_SUCCESS';
export const DELETE_JOB_DONE_FAIL = 'DELETE_JOB_DONE_FAIL';
export const DELETE_JOB_DONE_REQUEST = 'DELETE_JOB_DONE_REQUEST';

export const DELETE_MULTIPLE_JOBS_SUCCESS = 'DELETE_MULTIPLE_JOBS_SUCCESS';
export const DELETE_MULTIPLE_JOBS_FAIL = 'DELETE_MULTIPLE_JOBS_FAIL';
export const DELETE_MULTIPLE_JOBS_REQUEST = 'DELETE_MULTIPLE_JOBS_REQUEST';

export const POST_NEW_CALENDAR_EVENT_SUCCESS = 'POST_NEW_CALENDAR_EVENT_SUCCESS';
export const POST_NEW_CALENDAR_EVENT_FAIL = 'POST_NEW_CALENDAR_EVENT_FAIL';
export const POST_NEW_CALENDAR_EVENT_REQUEST = 'POST_NEW_CALENDAR_EVENT_REQUEST';

export const UPDATE_OVER_TIMES_REQUEST = 'UPDATE_OVER_TIMES_REQUEST';
export const UPDATE_OVER_TIMES_SUCCESS = 'UPDATE_OVER_TIMES_SUCCESS';
export const UPDATE_OVER_TIMES_FAIL = 'UPDATE_OVER_TIMES_FAIL';

export const GENERATE_WORK_HOURS_REQUEST = 'GENERATE_WORK_HOURS_REQUEST';
export const GENERATE_WORK_HOURS_SUCCESS = 'GENERATE_WORK_HOURS_SUCCESS';
export const GENERATE_WORK_HOURS_FAIL = 'GENERATE_WORK_HOURS_FAIL';

export const UPDATE_MULTIPLE_JOBS_REQUEST = 'UPDATE_MULTIPLE_JOBS_REQUEST';
export const UPDATE_MULTIPLE_JOBS_SUCCESS = 'UPDATE_MULTIPLE_JOBS_SUCCESS';
export const UPDATE_MULTIPLE_JOBS_FAIL = 'UPDATE_MULTIPLE_JOBS_FAIL';

export const UPDATE_USER_CURRENT_ACTIVITY = 'UPDATE_USER_CURRENT_ACTIVITY';
export const DELETE_USER_CURRENT_ACTIVITY = 'DELETE_USER_CURRENT_ACTIVITY';

export const TIME_TABLE_LAW_CHECK_REQUEST = 'TIME_TABLE_LAW_CHECK_REQUEST';
export const TIME_TABLE_LAW_CHECK_SUCCESS = 'TIME_TABLE_LAW_CHECK_SUCCESS';
export const TIME_TABLE_LAW_CHECK_FAIL = 'TIME_TABLE_LAW_CHECK_FAIL';
export const TIME_TABLE_LAW_CHECK_RESET = 'TIME_TABLE_LAW_CHECK_RESET';

const timeTableLawCheckRequest = () => ({ type: TIME_TABLE_LAW_CHECK_REQUEST });
export const timeTableLawCheckSuccess = (payload) => ({ type: TIME_TABLE_LAW_CHECK_SUCCESS, payload });
const timeTableLawCheckFail = () => ({ type: TIME_TABLE_LAW_CHECK_FAIL });
export const timeTableLawCheckReset = () => ({ type: TIME_TABLE_LAW_CHECK_RESET });

const updateOverTimesRequest = () => ({ type: UPDATE_OVER_TIMES_REQUEST });
const updateOverTimesSuccess = () => ({ type: UPDATE_OVER_TIMES_SUCCESS });
const updateOverTimesFail = (error) => ({ type: UPDATE_OVER_TIMES_FAIL, error });

const loadUserJobsRequest = () => ({ type: LOAD_USER_JOBS_REQUEST });
const loadUserJobsFail = (error) => ({ type: LOAD_USER_JOBS_FAIL, error });
const loadUserJobsSuccess = (userJobs) => ({ type: LOAD_USER_JOBS_SUCCESS, userJobs });

const loadCalendarEventsRequest = () => ({ type: LOAD_CALENDAR_EVENTS_REQUEST });
const loadCalendarEventsFail = (error) => ({ type: LOAD_CALENDAR_EVENTS_FAIL, error });
const loadCalendarEventsSuccess = (calendarEvents) => ({ type: LOAD_CALENDAR_EVENTS_SUCCESS, calendarEvents });

const loadFaultyEventsRequest = () => ({ type: LOAD_FAULTY_EVENTS_REQUEST });
const loadFaultyEventsFail = (error) => ({ type: LOAD_FAULTY_EVENTS_FAIL, error });
const loadFaultyEventsSuccess = (faultyEvents) => ({ type: LOAD_FAULTY_EVENTS_SUCCESS, faultyEvents });

const loadUserJobsInPeriodRequest = () => ({ type: LOAD_USER_JOBS_IN_PERIOD_REQUEST });
const loadUserJobsInPeriodFail = (error) => ({ type: LOAD_USER_JOBS_IN_PERIOD_FAIL, error });
const loadUserJobsInPeriodSuccess = (userJobsInPeriod) => ({ type: LOAD_USER_JOBS_IN_PERIOD_SUCCESS, userJobsInPeriod });

const loadUserJobsInDayRequest = () => ({ type: LOAD_USER_JOBS_IN_DAY_REQUEST });
const loadUserJobsInDayFail = (error) => ({ type: LOAD_USER_JOBS_IN_DAY_FAIL, error });
const loadUserJobsInDaySuccess = (userJobsInDay) => ({ type: LOAD_USER_JOBS_IN_DAY_SUCCESS, userJobsInDay });

const loadTotalWorkInPeriodRequest = () => ({ type: LOAD_TOTAL_WORK_IN_PERIOD_REQUEST });
const loadTotalWorkInPeriodFail = (error) => ({ type: LOAD_TOTAL_WORK_IN_PERIOD_FAIL, error });
const loadTotalWorkInPeriodSuccess = (userJobs) => ({ type: LOAD_TOTAL_WORK_IN_PERIOD_SUCCESS, userJobs });

const putJobDoneRequest = () => ({ type: PUT_JOB_DONE_REQUEST });
const putJobDoneFail = (error) => ({ type: PUT_JOB_DONE_FAIL, error });
const putJobDoneSuccess = (jobDone, params) => ({ type: PUT_JOB_DONE_SUCCESS, jobDone, params });

const deleteJobDoneRequest = () => ({ type: DELETE_JOB_DONE_REQUEST });
const deleteJobDoneFail = (error) => ({ type: DELETE_JOB_DONE_FAIL, error });
const deleteJobDoneSuccess = (eventCalendarId) => ({ type: DELETE_JOB_DONE_SUCCESS, eventCalendarId });

const deleteMultipleJobsRequest = () => ({ type: DELETE_MULTIPLE_JOBS_REQUEST });
const deleteMultipleJobsFail = (error) => ({ type: DELETE_MULTIPLE_JOBS_FAIL, error });
const deleteMultipleJobsSuccess = (eventCalendarIds) => ({ type: DELETE_MULTIPLE_JOBS_SUCCESS, eventCalendarIds });

const postCalendarEventSuccess = (calendarEvent, departmentName) => ({ type: POST_NEW_CALENDAR_EVENT_SUCCESS, calendarEvent, departmentName });
const postCalendarEventRequest = () => ({ type: POST_NEW_CALENDAR_EVENT_REQUEST });
const postCalendarEventFail = (error) => ({ type: POST_NEW_CALENDAR_EVENT_FAIL, error });

const generateWorkHoursRequest = () => ({ type: GENERATE_WORK_HOURS_REQUEST });
const generateWorkHoursSuccess = () => ({ type: GENERATE_WORK_HOURS_SUCCESS });
const generateWorkHoursFail = () => ({ type: GENERATE_WORK_HOURS_FAIL });

const updateMultipleEventsRequest = () => ({ type: UPDATE_MULTIPLE_JOBS_REQUEST });
const updateMultipleEventsSuccess = (data) => ({ type: UPDATE_MULTIPLE_JOBS_SUCCESS, data });
const updateMultipleEventsFail = (err) => ({ type: UPDATE_MULTIPLE_JOBS_FAIL, err });

const updateUserCurrentActivity = (userId, userCurrentActivity) => ({ type: UPDATE_USER_CURRENT_ACTIVITY, userId, userCurrentActivity });
const deleteUserCurrentActivity = (userId) => ({ type: DELETE_USER_CURRENT_ACTIVITY, userId });

export function loadCalendarEvents(params) {
  return (dispatch) => {
    dispatch(loadCalendarEventsRequest());
    const withSlipTimes = params.CalculateSlipTimes;
    const requests = [
      withSlipTimes ? wtsApi.v2.virtualEventSearchCreate({ ...params, CalculateSlipTimes: true }) : Promise.resolve(null),
      wtsApi.v2.virtualEventSearchCreate({ ...params, CalculateSlipTimes: false })
    ];
    return Promise.all(requests)
      .then(([data, dataWithoutSlipTimes]) => {
        const inputData = {
          dataWithSlipTimes: data?.data.Data,
          dataWithoutSlipTimes: dataWithoutSlipTimes?.data.Data
        };
        const parsedData = new VirtualEventsTable(params, inputData);
        dispatch(loadCalendarEventsSuccess(parsedData));
        if (!inputData.dataWithoutSlipTimes?.Persons?.length) {
          toastr.warning(I18n.t('NoDataAvailable'), '');
        }
      })
      .catch((error) => {
        console.error(error);
        dispatch(loadCalendarEventsFail(error));
        toastrError(error);
      });
  };
}

export const timeTableLawCheck = (params) => (dispatch) => {
  dispatch(timeTableLawCheckRequest());
  return communicate({ url: 'Verifications', method: 'get', getParams: Utils.objects.getQueryStringFromObject(params) })
    .then((response) => {
      dispatch(timeTableLawCheckSuccess(response.data.Data));
    })
    .catch((error) => {
      dispatch(timeTableLawCheckFail());
      toastrError(error);
    });
};

export const updateManyUsersJobsInPeriod = (payload) => (dispatch) => {
  dispatch({ type: UPDATE_MANY_USERS_JOBS_IN_PERIOD, payload });
};

export const loadUserJobs = (params) => (dispatch) => {
  dispatch(loadUserJobsRequest());
  return communicate({
    url: 'Jobs',
    method: 'get',
    getParams: Utils.objects.getQueryStringFromObject(params)
  }).then((response) => {
    dispatch(loadUserJobsSuccess(response.data.Data));
  }).catch((error) => {
    dispatch(loadUserJobsFail(error));
    toastrError(error);
  });
};

export const calendarEventRequest = (params) => communicate({
  url: 'CalendarEvents',
  getParams: Utils.objects.getQueryStringFromObject(params)
});

export const POSTCalendarEventRequest = (params) => communicate({
  url: 'CalendarEvents',
  method: 'post',
  data: params
});

export const putMultipleCalendarEventsRequest = (data) => communicate({
  url: 'CalendarEvents/Multiple',
  method: 'put',
  data
});

export const postCreateAndUpdateMultipleCalendarEventsRequest = (data) => communicate({
  url: 'CalendarEvents/MultipleCalendarEvents',
  method: 'post',
  data
});

export const deleteMultipleCalendarEventsRequest = (ids) => communicate({
  url: 'CalendarEvents/DeleteMany',
  method: 'post',
  getParams: Utils.objects.getQueryStringFromObject({ currentDateTime: dayjs().format(WTS_MOMENT_DATE_MASK) }),
  data: ids
});

export const getConfirmMainReportUsersRequest = (request) => communicate({
  url: 'ConfirmationDatas/ConfirmMainReportUsers',
  method: 'get',
  getParams: Utils.objects.getQueryStringFromObject({ currentDateTime: dayjs().format(WTS_MOMENT_DATE_MASK), ...request })
});

export const loadFaultyEvents = (params) => (dispatch) => {
  dispatch(loadFaultyEventsRequest());
  return calendarEventRequest(params)
    .then((response) => {
      if (!response.data.Data.length) {
        toastr.warning(I18n.t('NoDataAvailable'));
      }
      dispatch(loadFaultyEventsSuccess(response.data.Data));
    }).catch((error) => {
      dispatch(loadFaultyEventsFail(error));
      toastrError(error);
    });
};

export const loadUserJobsInPeriodWithoutAbsences = (params) => (dispatch) => {
  dispatch(loadUserJobsInPeriodRequest());
  return communicate({ url: 'CalendarEvents', method: 'get', getParams: Utils.objects.getQueryStringFromObject(params) })
    .then(({ data }) => {
      const events = pathOr([], ['Data'], data);
      dispatch(loadUserJobsInPeriodSuccess(events));
    })
    .catch((error) => {
      dispatch(loadUserJobsInPeriodFail(error));
      toastrError(error);
    });
};

export const loadUserJobsInPeriod = (params) => (dispatch) => {
  const { userIds, period } = params;
  dispatch(loadUserJobsInPeriodRequest());
  return Promise
    .all([
      communicate({ url: 'CalendarEvents', method: 'get', getParams: Utils.objects.getQueryStringFromObject(params) }),
      communicate({
        url: 'Events/LeavesForCalendar',
        method: 'get',
        getParams: Utils.objects.getQueryStringFromObject({ userIds, period })
      })
    ])
    .then(([eventsResponse, leavesResponse]) => {
      const events = pathOr([], ['data', 'Data'], eventsResponse);
      const leaves = map((event) => ({
        ...event,
        IsLeave: true
      }), pathOr([], ['data', 'Data'], leavesResponse));
      const userJobs = union(events, leaves);
      dispatch(loadUserJobsInPeriodSuccess(userJobs));
    }).catch((error) => {
      dispatch(loadUserJobsInPeriodFail(error));
      toastrError(error);
    });
};

export const loadUserJobsInDay = (params) => (dispatch) => {
  dispatch(loadUserJobsInDayRequest());
  return communicate({
    url: 'CalendarEvents',
    method: 'get',
    getParams: Utils.objects.getQueryStringFromObject(params)
    /* getParams: `?userId=${params.UserId}&startDate=${params.startTime}&endDate=${params.endTime}` */
  }).then((response) => {
    dispatch(loadUserJobsInDaySuccess(response.data.Data));
  }).catch((error) => {
    dispatch(loadUserJobsInDayFail(error));
    toastrError(error);
  });
};

export const loadUserCurrentActivity = (userId) => (dispatch) => {
  const payload = {
    currentDateTime: dayjs().format(WTS_MOMENT_DATE_MASK),
    userIds: userId,
    orderBy: 'TimeDesc'
  };
  return communicate({
    url: 'CalendarEvents/CurrentActivities',
    method: 'get',
    getParams: Utils.objects.getQueryStringFromObject(payload)
  })
    .then((response) => {
      const currentActivity = response.data.Data[0];
      if (currentActivity?.Event && !currentActivity.Event.EndTime) {
        dispatch(updateUserCurrentActivity(userId, response.data.Data[0]));
      } else {
        dispatch(deleteUserCurrentActivity(userId));
      }
    })
    .catch((error) => {
      toastrError(error);
    });
};

export const completeUserCurrentActivity = (currentUserActivity) => (dispatch) => { // DalUserCalendarEvent
  const payload = {
    Id: currentUserActivity.Event.Id,
    DepartmentId: currentUserActivity.Event.Department.Id,
    DepartmentName: currentUserActivity.Event.Department.Name,
    EndDate: dayjs().format(WTS_MOMENT_DATE_MASK),
    JobId: currentUserActivity.Event.Job.Id,
    StartDate: currentUserActivity.Event.StartTime,
    UserId: currentUserActivity.User.Id,
    Comment: currentUserActivity.Event.Comment
  };
  return communicate({
    url: 'CalendarEvents',
    method: 'put',
    data: payload
  })
    .then((response) => {
      toastrSuccess(response);
      dispatch(deleteUserCurrentActivity(payload.userId));
    })
    .catch((error) => {
      toastrError(error);
    });
};

export const loadTotalWorkInPeriod = (params) => (dispatch) => {
  dispatch(loadTotalWorkInPeriodRequest());
  return communicate({
    url: 'Reports/TotalWorkInPeriod',
    method: 'get',
    getParams: Utils.objects.getQueryStringFromObject({
      ...params,
      currentDateTime: dayjs().format(WTS_MOMENT_DATE_MASK)
    })
    /* getParams: `?UserId=${params.UserId}&StartTime=${params.startTime}&EndTime=${params.endTime}` */
  }).then((response) => {
    dispatch(loadTotalWorkInPeriodSuccess(response.data.Data));
  }).catch((error) => {
    dispatch(loadTotalWorkInPeriodFail(error));
    toastrError(error);
  });
};

export const editJobDone = (params) => (dispatch) => {
  dispatch(putJobDoneRequest());
  return communicate({
    url: 'CalendarEvents',
    method: 'put',
    data: params
    // getParams: `?UserId=${params.UserId}&startTime=${params.startTime}&endTime=${params.endTime}`
  }).then((response) => {
    dispatch(putJobDoneSuccess(response.data.Data, params));
    toastrSuccess(response);
  }).catch((err) => {
    dispatch(putJobDoneFail(err));
    toastrError(err);
  });
};

export const updateMultipleJobs = (data) => (dispatch) => {
  dispatch(updateMultipleEventsRequest());
  return putMultipleCalendarEventsRequest(data)
    .then((response) => {
      dispatch(updateMultipleEventsSuccess(response.data.Data, data));
      toastrSuccess(response);
    })
    .catch((err) => {
      dispatch(updateMultipleEventsFail(err));
      toastrError(err);
    });
};

export const deleteJobDone = (eventCalendarId) => (dispatch) => {
  dispatch(deleteJobDoneRequest());
  return communicate({
    url: 'CalendarEvents',
    method: 'delete',
    getParams: Utils.objects.getQueryStringFromObject(eventCalendarId)
  }).then((response) => {
    dispatch(deleteJobDoneSuccess(eventCalendarId.id));
    toastrSuccess(response);
  }).catch((error) => {
    dispatch(deleteJobDoneFail(error));
    toastrError(error);
  });
};

export const postCalendarEvent = (params) => (dispatch) => {
  dispatch(postCalendarEventRequest());
  return POSTCalendarEventRequest(params)
    .then((response) => {
      dispatch(postCalendarEventSuccess(response.data.Data, params.DepartmentName));
      toastrSuccess(response);
    }).catch((error) => {
      dispatch(postCalendarEventFail(error));
      toastrError(error);
    });
};

export const generateWorkHours = (params) => (dispatch) => {
  dispatch(generateWorkHoursRequest());
  return communicate({ url: 'CalendarEvents/Generate', method: 'post', data: params })
    .then((response) => {
      dispatch(generateWorkHoursSuccess());
      toastrSuccess(response);
      return true;
    })
    .catch((error) => {
      dispatch(generateWorkHoursFail(error));
      toastrError(error);
      return false;
    });
};

const getUpdateData = ({ Id, StartOverTime, EndOverTime }) => ({
  id: Id,
  StartOverTime,
  EndOverTime
});

export const updateOverTimes = (request) => (dispatch) => {
  dispatch(updateOverTimesRequest());
  const requests = request.end
    ? [
      communicate({ url: 'Events/SetEventOverTime', method: 'put', data: getUpdateData(request.start) }),
      communicate({ url: 'Events/SetEventOverTime', method: 'put', data: getUpdateData(request.end) })
    ]
    : [
      communicate({ url: 'Events/SetEventOverTime', method: 'put', data: getUpdateData(request.start) })
    ];
  return Promise.all(requests)
    .then((response) => {
      toastrSuccess(response[0]);
      dispatch(updateOverTimesSuccess());
    })
    .catch((err) => {
      toastrError(err);
      dispatch(updateOverTimesFail('Error updating event'));
    });
};

export const deleteMultipleEvents = (ids) => (dispatch) => {
  dispatch(deleteMultipleJobsRequest());
  return deleteMultipleCalendarEventsRequest(ids)
    .then((response) => {
      toastrSuccess(response);
      dispatch(deleteMultipleJobsSuccess(ids));
    })
    .catch((error) => {
      toastrError(error);
      dispatch(deleteMultipleJobsFail(error));
    });
};

export const getEmployeeOpenEvents = (params) => communicate({
  url: 'CalendarEvents/OpenEvents',
  getParams: Utils.objects.getQueryStringFromObject(params)
});
